import { ReactNode, CSSProperties } from 'react';
import styled from 'styled-components';

interface TextConfig {
	size?: number;
	color?: string;
	weight?: 'light' | 'medium' | 'semi-bold' | 'bold' | 'heavy' | 'black';
	style?: CSSProperties;
	center?: boolean;
	onClick?: () => void;
	children?: ReactNode;
	className?: string;
}

export const Text: React.FC<TextConfig> = ({ children, style, size, color, weight, center, onClick, className }) => {
	return (
		<TextBody
			$size={size}
			$color={color}
			$weight={weight}
			$center={center}
			style={style}
			onClick={onClick}
			className={className}
		>
			{children}
		</TextBody>
	);
};

const TextBody = styled.p<{
	$size?: number;
	$color?: string;
	$weight?: TextConfig['weight'];
	$center?: boolean;
}>`
	${({ $size, $color, $weight, $center }) => `
  font-size: ${$size || 16}px;
  color: ${$color || 'black'};
	width: fit-content;
  font-weight: ${$weight === 'black' ? 900 : $weight === 'heavy' ? 800 : $weight === 'bold' ? 700 : $weight === 'semi-bold' ? 600 : $weight === 'light' ? 400 : 500};
	${$center ? 'text-align:center;' : ''}
  `}
`;
